import React from "react";
import PropTypes from "prop-types";
import { CommentItem } from "components";
import "./styles.css";
import { connect } from "react-redux";
import * as actions from "redux/actions/commentActions";
import MiniLoader from "components/MiniLoader";
import { Translate } from "react-redux-i18n";

const Comments = (props) => {
    const onClickUp = (item) => {
        props.updateLike({
            comment_id: item.id,
            id: props.user_id,
            reaction: "1",
        }, props.token);
    };

    const onClickDown = (item) => {
        props.updateLike({
            comment_id: item.id,
            id: props.user_id,
            reaction: "2",
        }, props.token);
    };

    const onClickComment = (item) => {
        props.setItem(item);
    };

    if (props.loading) {
        return (
            <div className="wall-container profile-comments">
                <MiniLoader />
            </div>
        );
    }

    if (!props.list.length) {
        return (
            <div className="wall-container profile-comments profile-comments-empty">
                <Translate value="no_posts" />
            </div>
        );
    }

    return (
        <div className="wall-container profile-comments">
            {props.list.map((item) => (
                <CommentItem
                    key={item.id}
                    item={item}
                    onClickUp={() => onClickUp(item)}
                    onClickDown={() => onClickDown(item)}
                    onClickComment={() => onClickComment(item)}
                />
            ))}
        </div>
    );
};

Comments.propTypes = {
    className: PropTypes.string,
    followerId: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.comment.list,
        error: reducer.comment.error,
        loading: reducer.comment.loading,
    };
}

const mapDispatchToProps = dispatch => ({
    updateLike: (params, token) =>
        dispatch(actions.updateLike({ params, token })),
    setItem: (item) =>
        dispatch(actions.setItem({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
